import { COLOR } from '@src/styles/color';
import { Skeleton } from '@mui/material';
import SubjectRoundedIcon from '@mui/icons-material/SubjectRounded';
import React from 'react';
import Typography from '@src/new-components/Typography';
import IconLabel from '@src/new-components/IconLabel';
import GroupsRounded from '@mui/icons-material/GroupsRounded';
import { useTranslation } from 'react-i18next';
import { formatNumberWithSuffix } from '@src/utils/number';
import {
  StyledCreditConverter,
  StyledVoiceDataInfo,
  StyledVoiceDataInfoItemColumn,
  StyledVoiceDataInfoItemRow,
} from '../index.style';

const VoiceDataInfo = ({ voice, isLoading }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <StyledVoiceDataInfo>
      {isLoading ? (
        <Skeleton
          style={{ borderRadius: '10px', marginTop: 8 }}
          variant="rectangular"
          animation="wave"
          width={140}
          height={48}
        />
      ) : (
        voice?.code && (
          <StyledCreditConverter>
            <StyledVoiceDataInfoItemRow>
              <IconLabel
                customStyle={{
                  justifyContent: 'center',
                }}
                icon={
                  <SubjectRoundedIcon
                    sx={{
                      color: COLOR.navyBlue,
                      fontSize: 16,
                    }}
                  />
                }
                value={formatNumberWithSuffix(
                  voice?.totalCredits ?? 0,
                  language,
                )}
                textVariant="body-16-bold"
                textColor={COLOR.descriptionGray}
              />
              <Typography
                variant="body-12-regular"
                color={COLOR.descriptionUpload}
              >
                {t('totalCharactersUsed')}
              </Typography>
            </StyledVoiceDataInfoItemRow>
          </StyledCreditConverter>
        )
      )}
      {isLoading ? (
        <Skeleton
          style={{ borderRadius: '10px', marginTop: 16 }}
          variant="rectangular"
          animation="wave"
          width={140}
          height={24}
        />
      ) : (
        voice?.code && (
          <StyledVoiceDataInfoItemColumn marginTop={16}>
            <IconLabel
              icon={
                <GroupsRounded
                  sx={{ color: COLOR.navyBlue, width: 16, height: 16 }}
                />
              }
              value={formatNumberWithSuffix(voice?.totalUsers ?? 0, language)}
              tooltip={t('totalUsersUsed')}
              textVariant="body-14-regular"
            />
            <Typography
              variant="body-14-regular"
              color={COLOR.descriptionUpload}
            >
              {t('numUsersUseVoice')}
            </Typography>
          </StyledVoiceDataInfoItemColumn>
        )
      )}
    </StyledVoiceDataInfo>
  );
};

export default VoiceDataInfo;
